import { AxiosResponse } from 'axios';

import { SCIApi, selfCheckInRoute } from 'src/apis';

import {
    RentalArrivalTime,
    CreateRentalArrivalTimePayload,
    UpdateRentalArrivalTimePayload,
} from '../arrivalTime.types';

export const arrivalTimeApiRoute = `${selfCheckInRoute}/rentals/arrival-times`;

export const getArrivalTime = async (): Promise<RentalArrivalTime> => {
    const apiCalls = SCIApi.getInstance();

    const axiosResult: AxiosResponse<RentalArrivalTime> =
    await apiCalls.get<RentalArrivalTime>(arrivalTimeApiRoute);
    const result = axiosResult?.data ?? axiosResult;

    return result;
};

export const createRentalArrivalTime =
    async (createRentalArrivalTimePayload: CreateRentalArrivalTimePayload): Promise<void> => {
        const apiCalls = SCIApi.getInstance();

        await apiCalls.post<void>(
            arrivalTimeApiRoute,
            createRentalArrivalTimePayload,
        );
    };

export const updateRentalArrivalTime =
    async (rentalArrivalTimeId: string, updateRentalArrivalTimePayload: UpdateRentalArrivalTimePayload): Promise<void> => {
        const apiCalls = SCIApi.getInstance();

        await apiCalls.put<void>(
            `${arrivalTimeApiRoute}/${rentalArrivalTimeId}`,
            updateRentalArrivalTimePayload,
        );
    };
